const actionReducer = (state = null, action) => {
    return action;
};

export default actionReducer;
